import React, { useEffect, useState } from 'react';
import { Navigate, Route, Routes } from 'react-router';
import { useNavigate } from 'react-router-dom';

import Navbar from '../js/components/Navbar/Navbar';
import SmoothScroll from './extra/SmoothScroll';
import Error404 from './extra/Error404';
import PrivateRoute from './extra/ProtectedRoute';
import LoadingScreen from './extra/LoadingScreen';
import HomePage from '../js/pages/HomePage';
import MakersharksDashboard from '../js/pages/Makersharks/MakersharksDashboard';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

const MakersharksLayout = () => {
  const navigate = useNavigate();
  const [isNavHidden, setIsNavHidden] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 700);

    navigate('/makersharks');
  }, []);

  return (
    <div className="flex flex-col justify-between">
      {isLoading ? (
        <LoadingScreen />
      ) : (
        <>
          <div className={classNames('navBar', isNavHidden && 'hidden')}>
            <Navbar />
          </div>
          <SmoothScroll>
            <Routes>
              {/* common routes not requiring user role or login */}

              <Route path="makersharks" element={<PrivateRoute />}>
                <Route path="" element={<HomePage />} />

                {/* default layout for buyer/new user */}
                <Route path="dashboard" element={<MakersharksDashboard />} />

                {/* for any other routes which does not exist */}
                <Route path="404" element={<Error404 />} />
                <Route
                  path="*"
                  /* todo:change navigation to /404 */
                  element={<Navigate to="/" replace />}
                />
              </Route>

              {/* for any other routes which does not exist */}
              <Route path="/404" element={<Error404 />} />
              <Route
                path="*"
                /* todo:change navigation to /404 */
                element={<Navigate to="/" replace />}
              />
            </Routes>
          </SmoothScroll>
        </>
      )}
    </div>
  );
};

export default MakersharksLayout;
